'use strict';

import config from '../../config';
import axios from 'axios';
import qs from 'qs';
import vueCookies from 'vue-cookies';
import {
  MessageBox
} from 'element-ui';
import state from '../../store/state.js';

const messages = {
  zh: {
    LOGIN_ELSEWHERE: "您的账号已在他处登录！",
    SESSION_EXPIRATION:"会话过期，请重新登陆！",
    NOTICE: "提示",
    CONFIRM: "确认"
  },
  en: {
    LOGIN_ELSEWHERE: "Your account has been logged in elsewhere.",
    SESSION_EXPIRATION:"Session expired, Please login again.",
    NOTICE: 'Notice',
    CONFIRM: "Confirm"
  }
}

function once(fn) {

  var isImplementing = false;

  return function() {

    if (!isImplementing) {
      isImplementing = true;
      fn ? fn.apply(this, arguments) : '';
    }

  }

}

const confirmOnce = once(function(code) {
  let message;
  switch (code){
    case 401:
    message=messages[state.lang].SESSION_EXPIRATION;
    break;
    case 402:
    message=messages[state.lang].LOGIN_ELSEWHERE;
    break;
  }
  MessageBox.confirm(message, messages[state.lang].NOTICE, {
    type: 'warning',
    showCancelButton: false,
    showClose: false,
    closeOnHashChange:false,
    closeOnPressEscape:false,
    closeOnClickModal:false,
    confirmButtonClass: 'origin',
    confirmButtonText: messages[state.lang].CONFIRM
  }).then(() => {
    window.location.href = '/login';
  }).catch(() => {

  })
});

axios.defaults.crossDomain = true;
axios.defaults.withCredentials = true;

const service = axios.create({
  baseURL: config.API_URL + '/api',
  timeout: 1000*60
});

function debounce(fn, delay) {
  var timer;
  return function() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      fn ? fn.apply(this, arguments) : '';
    }, delay || 0);
  }
};

// 添加request拦截器
service.interceptors.request.use(config => {
  return config;
}, error => {
  return Promise.reject(error);
});
// 添加respone拦截器
service.interceptors.response.use(
  response => {
    if (response && response.data && (response.data.code==402 || response.data.code==401)) {
      //防止lang更新不及时
      // setTimeout(() => {
      //   confirmOnce(response.data.code);
      // }, 1000);
    }
    return Promise.resolve(response.data);
  },
  error => {
    if(error && error.response && (error.response.status==402 || error.response.status==401)){
      // if(state.oemCompany.other && JSON.parse(state.oemCompany.other).login_url){
      //   window.location.href = JSON.parse(state.oemCompany.other).login_url;
      // }
      //防止lang更新不及时
      // setTimeout(() => {
      //   confirmOnce(error.response.status);
      // }, 1000);
    }
    if(error.code == 'ECONNABORTED' && error.message.indexOf('timeout')!=-1){
      error=60005;
    }
    return Promise.resolve({
      code: error && error.response ? error.response.status : error,
      msg: 'Invalid request'
    });
  }
);

export default {
  post: function(url, data = {}, config = {}) {
    return service.post(url, qs.stringify(data, { ...config
    }), {
      headers: {
        'oemToken': vueCookies.get('oemToken') || '',
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  },
  jsonPost: function(url, data = {}, apiUrl) {
    var API_URL =  apiUrl? apiUrl : config.API_URL+ '/api'
    return axios(API_URL  + url, {
      method: 'POST',
      mode: 'no-cors',
      data: JSON.stringify(data),
      headers: {
        'oemToken': vueCookies.get('oemToken') || '',
        'Content-Type': 'application/json'
      },
      withCredentials: true,
      credentials: 'same-origin',
    });
    
    // return service.post(url, JSON.stringify(data), {
    //     headers: {
    //       // 'Content-Type': 'application/x-www-form-urlencoded'
    //       'Content-Type': 'application/json'
    //     }
    //   });
  },

  get: function(url, params,apiUrl, setting = {},) {
    var API_URL = apiUrl ? apiUrl : config.API_URL+ '/api'
    var newHearders = {
      'Content-Type': 'application/json'
    }
    if(vueCookies.get('ts-token') ){
      newHearders['ts-token'] = vueCookies.get('ts-token');
    }
    if(vueCookies.get('oemToken')){
      delete newHearders['ts-token'];
      newHearders['oemToken'] = vueCookies.get('oemToken');
    }
    return axios(API_URL  + url, {
      method: 'GET',
      // mode: 'no-cors',
      params: params,
      headers: newHearders,
        paramsSerializer: target => qs.stringify(target, {
        arrayFormat: setting.arrayFormat
      })
    });

    // return service.get(url, {
    //   params: params,
    //   paramsSerializer: target => qs.stringify(target, {
    //     arrayFormat: config.arrayFormat
    //   })
    // }, {
    //   headers: {
    //     'oemToken': vueCookies.get('oemToken') || vueCookies.get('ts-token'),
    //     'Content-Type': 'application/x-www-form-urlencoded'
    //   }
      
    // });
   
  },
  delete:function(url, data = {}) {
    return service.delete(url, {
      headers: {
        'oemToken': vueCookies.get('oemToken') || '',
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: qs.stringify(data)
    });
  },
  put: function (url, data = {}) {
    return service.put(url, qs.stringify(data, {...config}),
      {
        headers: {
          'oemToken': vueCookies.get('oemToken') || '',
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
  },
  del: function(url, data = {}) {
    return service.delete(url, {
      headers: {
        'oemToken': vueCookies.get('oemToken') || '',
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: qs.stringify(data)
    });
  }
};



// WEBPACK FOOTER //
// ./src/common/service/api-service.js